const mediaItems = [
  {
    title: '刃牙动画PV：地下斗技场',
    desc: '刃牙第一部动画化精彩PV，热血沸腾的地下斗技场战斗画面精选。',
    duration: '02:35',
    views: '128万',
    img: 'https://readdy.ai/api/search-image?query=Anime%20style%20fighting%20scene%20thumbnail%2C%20dramatic%20manga%20art%20in%20motion%20feel%2C%20two%20fighters%20in%20arena%20with%20intense%20lighting%2C%20warm%20crimson%20and%20amber%20color%20scheme%2C%20cinematic%20composition%2C%20brushstroke%20textures%2C%20no%20text&width=640&height=360&seq=media-baki-1&orientation=landscape',
  },
  {
    title: '刃牙II：最凶死刑犯PV',
    desc: '五名死刑犯越狱挑战全日本格斗家，系列最经典篇章动画化。',
    duration: '03:12',
    views: '96万',
    img: 'https://readdy.ai/api/search-image?query=Dark%20prison%20break%20anime%20style%20thumbnail%2C%20shadowy%20figures%2C%20dramatic%20lighting%20with%20crimson%20undertones%2C%20intense%20atmosphere%2C%20manga%20brushstroke%20style%2C%20cinematic%20wide%20composition%2C%20no%20text&width=640&height=360&seq=media-baki-2&orientation=landscape',
  },
  {
    title: '范马刃牙：父子决战名场面',
    desc: '史上最强父子之战完整回顾，范马刃牙与勇次郎的终极对决。',
    duration: '05:48',
    views: '215万',
    img: 'https://readdy.ai/api/search-image?query=Epic%20father%20son%20battle%20anime%20style%20thumbnail%2C%20stormy%20sky%20with%20two%20powerful%20silhouettes%2C%20dramatic%20golden%20and%20crimson%20lighting%2C%20brushstroke%20ink%20effects%2C%20cinematic%20composition%2C%20no%20text&width=640&height=360&seq=media-baki-3&orientation=landscape',
  },
  {
    title: '刃牙道：宫本武藏动画PV',
    desc: '传奇剑豪宫本武藏复活篇动画PV，跨时代战斗序幕拉开。',
    duration: '02:56',
    views: '87万',
    img: 'https://readdy.ai/api/search-image?query=Samurai%20sword%20anime%20style%20thumbnail%2C%20traditional%20japanese%20aesthetic%20with%20modern%20manga%20fusion%2C%20dramatic%20katana%20with%20energy%20effects%2C%20warm%20amber%20lighting%2C%20brushstroke%20textures%2C%20cinematic%20composition%2C%20no%20text&width=640&height=360&seq=media-baki-4&orientation=landscape',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 text-center mb-3">
          视频专区
        </h2>
        <p className="text-sm text-foreground-600 text-center mb-10 max-w-lg mx-auto">
          刃牙漫画系列动画PV与名场面精选，感受视觉化的热血格斗
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {mediaItems.map((item, i) => (
            <div key={i} className="group cursor-pointer">
              <div className="relative rounded-xl overflow-hidden mb-3 aspect-video bg-background-200">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-black/20 group-hover:bg-black/35 transition-colors flex items-center justify-center">
                  <div className="w-12 h-12 rounded-full bg-white/90 flex items-center justify-center group-hover:scale-110 transition-transform">
                    <i className="ri-play-fill text-xl text-primary-600 ml-0.5"></i>
                  </div>
                </div>
                <span className="absolute bottom-2 right-2 px-2 py-0.5 text-[11px] font-medium bg-black/70 text-white rounded whitespace-nowrap">
                  {item.duration}
                </span>
              </div>
              <h3 className="font-heading text-sm font-bold text-foreground-900 mb-1 group-hover:text-primary-600 transition-colors line-clamp-1">
                {item.title}
              </h3>
              <p className="text-xs text-foreground-600 leading-relaxed line-clamp-2 mb-1">{item.desc}</p>
              <span className="text-[11px] text-foreground-500">
                <i className="ri-eye-line mr-1"></i>{item.views} 次观看
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}